import { render, staticRenderFns } from "./WalletActions.vue?vue&type=template&id=0e06d2ce&lang=pug"
import script from "./WalletActions.vue?vue&type=script&lang=js"
export * from "./WalletActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports